import React, { useContext, useEffect, useState } from 'react';
import "./partRequestItemPart.css";
import HierarchyLines from '../../../../../TestLine/HierarchyLines';
import { Tooltip } from '@mui/material';
import { dropdownConfig } from '../../../../../services/dropdownsConfigService';
import { HTTP_RESPONSE_CODES } from '../../../../../globals/globals';
import { Dropdowns } from '../../../../../components/Dropdowns/Dropdowns';
import { DialogContext } from '../../../../../contexts/DialogContext';
import { DeleteItemPartModal } from './DeletePartRequestItemPartModal/DeleteItemPartModal';
import { HistoryItemPart } from './HistoryPartRequestItemPart/HistoryItemPart';
import Input from '../../../../../components/Inputs/Input';
import { deletePartRequestDetailPart, getBatchesToPRN, getSerializedPRNParts, updatePartRequestDetailPart } from '../../../Services/partRequestService';
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import { usePermissions } from '../../../../../hooks/usePermissions';

export const PartRequestItemPart = ({ parentLenghts = 2, initialData, prnStatus, reloadParentList }) => {
  const [editionMode, setEditionMode] = useState(false);
  const [batchDrop, setBachDrop] = useState(null);
  const [batchSelected, setBatchSelected] = useState(null)
  const [preselectBatchDrop, setPreselectBatchDrop] = useState(null)

  const [SNDrop, setSNDrop] = useState(null);
  const [SNSelected, setSNSelected] = useState(null)
  const [preselectSNDrop, setPreselectSNDrop] = useState(null)
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [formData, setFormData] = useState({
    pn: "",
    qty: 0,
    uom: "",
    batch: "",
    sn: ""
  });

  const [bodyToUpdate, setBodyToUpdate] = useState(null);

  const [staticDataToAssigned, setStaticDataToAssigned] = useState([])
  const [staticDataToBatch, setStaticDataToBatch] = useState([])
  const { successMsg, errorMsg, warningMsg, infoMsg } = useSnackBar();
  const { hasPermission } = usePermissions();

  // functions

  const openDeleteDialog = () => {
    if (prnStatus == "Posted") {
      return;
    } else {
      openDialog({
        component: DeleteItemPartModal,
        props: {
          onClose: closeDialog,
          PNName: initialData?.part_number,
          Quantity: initialData?.quantity,
          deletePN: deleteItemPart
        }
      })
    }
  }

  const openHistoryDialog = () => {
    openDialog({
      component: HistoryItemPart,
      props: {
        onClose: closeDialog
      }
    })
  }

  const deleteItemPart = async () => {

    let request = await deletePartRequestDetailPart(initialData?.id)
    if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {
      reloadParentList()
      closeDialog()
      successMsg("Part Deleted", "The Part Has Been Deleted.")
    } else {
      errorMsg("Error Deleting Part", "An Error Occurred While Deleting The Part.")
      closeDialog()
    }
  }

  const toggleEditionMode = () => {
    setEditionMode(!editionMode);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setBodyToUpdate((prevState) => {
      return { ...prevState, quantity: parseInt(e.target.value) }
    })
  };

  const getDropdownConfigBatch = async () => {
    let id = 14;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setBachDrop(request.data.load);
    }
  }

  const getDropdownConfigSN = async () => {
    let id = 69;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSNDrop(request.data.load);
    }
  }

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigBatch(),
      getDropdownConfigSN(),
    ])

    return results
  }

  const getBatchSelected = (data) => {
    setBatchSelected(data)
    setFormData((prevState) => {
      return {
        ...prevState,
        qty: parseInt(data.value2)
      }
    })
    setBodyToUpdate((prevState) => {
      return { ...prevState, batchId: parseInt(data.id) }
    })
  }

  const getSNSelected = (data) => {
    setSNSelected(data)
    setBodyToUpdate((prevState) => {
      return { ...prevState, serializedPartId: parseInt(data.id) }
    })
    // setPreselectBatchDrop(data.value2)
  }

  const getSerialized = async () => {
    let request = await getSerializedPRNParts(initialData.part_id, initialData.company_id, initialData.location_id)

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setStaticDataToAssigned(request.data.load)
    }
  }

  const getBatch = async () => {
    let request = await getBatchesToPRN(initialData.part_id, initialData.company_id, initialData.location_id)

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setStaticDataToBatch(request.data.load)
    }
  }

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      batch: batchSelected?.name || "--",
      sn: SNSelected?.name || "--"
    }));

  }, [batchSelected, SNSelected]);

  const updatePart = async () => {
    if (!validateForm()) {
      return
    }
    let request = await updatePartRequestDetailPart(bodyToUpdate)

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      successMsg("Part Updated", "The Part Has Been Updated Succefully.")
      toggleEditionMode()
      reloadParentList()

    }
  }

  const validateForm = () => {

    if (initialData?.part_type == "Serialized") {

      if (!bodyToUpdate?.serializedPartId) {
        warningMsg("Select Serialized Part", "Please Select A Serialized Part.")
        return false
      } else if (!bodyToUpdate?.batchId) {
        warningMsg("Select Batch", "Please Select A Batch.")
        return false
      } else if (!formData.qty || formData.qty < initialData?.issued_quantity_posted || formData.qty == 0) {
        warningMsg("Invalid Quantity", "Enter a valid qty or make sure it is not less than the issued qty or 0.")
        return false
      } else {
        return true
      }
    } else if (initialData?.part_type !== "Serialized") {
      if (!bodyToUpdate?.batchId) {
        warningMsg("Select Batch", "Please Select A Batch.")
        return false
      } else if (!formData.qty || formData.qty < initialData?.issued_quantity_posted || formData.qty == 0) {
        warningMsg("Invalid Quantity", "Enter a valid qty or make sure it is not less than the issued qty or 0.")
        return false
      } else {
        return true
      }
    }
  }

  useEffect(() => {
    if (SNDrop) {
      setPreselectBatchDrop(parseInt(SNSelected?.value2) || null)
      setPreselectSNDrop(SNSelected?.serialized_part_id_selected || null)
    }
  }, [SNSelected])


  useEffect(() => {
    if (editionMode) {
      getAllDropdowns()
    }
  }, [editionMode])

  useEffect(() => {

    setFormData(() => {
      return {
        pn: initialData?.part_number ? initialData?.part_number : "--",
        qty: initialData?.quantity ? initialData?.quantity : "--",
        uom: initialData?.uom_name ? initialData?.uom_name : "--",
        sn: initialData?.serialized_part_number_selected ? initialData?.serialized_part_number_selected : "--",
        batch: initialData?.internal_batch ? initialData?.internal_batch : "--"
      }
    })

    // setPreselectSNDrop(initialData?.part_type ? initialData?.part_type : null);
    // setPreselectBatchDrop(initialData?.internal_batch ? initialData?.internal_batch : null)
    getSerialized()
    getBatch()
    setBodyToUpdate(
      () => {
        const newData = {
          id: parseInt(initialData?.id) || null,
          companyId: parseInt(initialData?.company_id) || null,
          serializedPartId: parseInt(initialData?.serialized_part_id_selected) || null,
          batchId: parseInt(initialData?.internal_batch) || null,
          locationId: parseInt(initialData?.location_id) || null,
          siteId: parseInt(initialData?.site_id) || null,
          rackId: parseInt(initialData?.rack_id) || null,
          shelfId: parseInt(initialData?.shelf_id) || null,
          binId: parseInt(initialData?.bin_id) || null,
          quantity: parseInt(initialData?.quantity) || 0,
          uomId: parseInt(initialData?.uom_id) || null,
          partId: parseInt(initialData?.part_id) || null,
          partRequest: {
            id: initialData?.part_request_id || null,
          }
        }
        return newData;
      }

    )

  }, [])


  return (
    <section className='partRequest-item-part' tabIndex={0}>
      {parentLenghts > 1 && (
        <HierarchyLines
          idx={-1}
          totalLength={1}
          depth={0}
          noChild={false}
          initialTop={62}
          zIndex={-1}
        ></HierarchyLines>
      )}

      <HierarchyLines
        idx={0}
        totalLength={1}
        depth={1}
        initialTop={62}
        zIndex={4}
      ></HierarchyLines>

      <span style={{
        zIndex: 0,
        backgroundColor:
          (initialData?.part_type == "Serialized" && initialData?.serialized_part_id_selected != null)
            ? "var(--green-250)" //serialized + id => green
            : (initialData?.part_type != "Serialized" && formData.qty <= initialData?.available_quantity)
              ? "var(--green-250)" //no serialized + qty <= available => green
              : (initialData?.available_quantity === 0 || initialData?.available_quantity === null && formData.qty > 0)
                ? "var(--red-300)" // no available quantity => red

                : (formData.qty > initialData?.available_quantity)
                  ? "var(--yellow-100)" // qty > available => yellow
                  : "var(--red-300)"
      }}>

      </span>

      <Tooltip title={formData.pn} arrow>
        <p style={{ width: "10%", minWidth: "4rem", marginLeft: ".5rem" }}>
          <span className='ellipsis'>{formData.pn}</span>
        </p>
      </Tooltip>
      <section style={{ width: "12%", minWidth: "4rem" }}>
        {editionMode ? (
          <div style={{
            width: "80%"
          }}>
            {
              SNDrop && initialData?.part_type == "Serialized" && hasPermission("editSN") ? <Dropdowns isStatic={true} preSelectValue={preselectSNDrop} staticData={staticDataToAssigned} hideLabel={true} placeholder={true} data={SNDrop} onOptionSelect={getSNSelected} staticDataColumnPreselection={"id"}></Dropdowns> : "--"
            }
          </div>

        ) : (
          <Tooltip title={formData.sn} arrow>
            <span className='ellipsis' style={{
              fontWeight: "600"
            }}>{formData.sn}</span>
          </Tooltip>
        )}
      </section>
      <section style={{ width: "11%", minWidth: "5rem" }}>
        {editionMode ? (
          <div style={{
            width: "80%"
          }}>
            {
              batchDrop && hasPermission("editB") ? <Dropdowns disabled={initialData?.part_type == "Serialized" ? true : false} isStatic={true} staticData={staticDataToBatch} hideLabel={true} placeholder={true} data={batchDrop} onOptionSelect={getBatchSelected} preventSelectionWithPreselect={false} staticDataColumnPreselection={"id"} preSelectValue={preselectBatchDrop}></Dropdowns> : "--"
            }
          </div>

        ) : (
          <Tooltip title={initialData?.internal_batch_name || "--"} arrow>
            <span className='ellipsis' style={{
              fontWeight: "600"
            }}> {initialData?.internal_batch_name || "--"}</span>
          </Tooltip>
        )}
      </section>
      {/* <p style={{ width: "9%", minWidth: "3rem" }}>

        <Tooltip title={formData.uom} arrow>
          <span className='ellipsis'>{formData.uom}</span>
        </Tooltip>

      </p> */}
      <p style={{ width: "8%", minWidth: "2rem" }}>
        {editionMode && hasPermission("editQ") ? (
          <Input style={{
            width: "3.5rem"
          }} disableAutocomplete={true} isNumeric={true} autoFocus={editionMode} name={"qty"} placeholder={"QTY"} value={formData.qty} onChange={handleChange} />
        ) : (
          <Tooltip title={formData.qty} arrow>
            <span className='ellipsis'>{`${formData.qty} ${initialData?.uom_abrevation}`}</span>
          </Tooltip>
        )}
      </p>
      <section id='issue-quantity-section-item-part' style={{
        width: "10%",
        minWidth: "5rem"
      }}>
        <Tooltip title={initialData.issued_quantity_posted ? initialData.issued_quantity_posted : 0} arrow>
          <div
          >{initialData.issued_quantity_posted ? initialData.issued_quantity_posted : 0}
          </div>
        </Tooltip>
      </section>
      <p style={{ width: "10%", minWidth: "3rem" }}>

        <Tooltip title={initialData?.remaining_quantity} arrow>
          <span className='ellipsis'>{initialData?.remaining_quantity ? initialData?.remaining_quantity : 0}</span>
        </Tooltip>

      </p>


      <div className='part-request-item-inventory-count-header'>
        {
          formData.qty > initialData?.issued_quantity_posted && <p className='insufficient-inventory-text'>Insufficient Inventory</p>
        }
        <Tooltip title="Change Log" arrow>
          <button onClick={openHistoryDialog} className='icon-open-log-part-request-part'>
            <i className='icon-stock'></i>
          </button>
        </Tooltip>
        <section style={{

          background: initialData?.quantity <= initialData?.issued_quantity_posted ? "#00CE881C" :
            initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted > 0 ? "#FFF5DF" :
              initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted == 0 ? "#FFF5DF" : "",

          border: initialData?.quantity <= initialData?.issued_quantity_posted ? "1px solid #00CE88" :
            initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted > 0 ? "1px solid #DFB050" :
              initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted == 0 ? "1px solid #DFB050" : ""

        }}>
          <p className='ellipsis'
            style={{
              color: initialData?.remaining_quantity <= 0 ? "#00CE88" :
                initialData?.remaining_quantity > 0 && initialData?.issued_quantity_posted > 0 ? "#DFB050" :
                  initialData?.remaining_quantity > 0 && initialData?.issued_quantity_posted == 0 ? "#DFB050" : "",
            }}
          >{
              initialData?.quantity <= initialData?.issued_quantity_posted ? "Issued" :
                initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted > 0 ? "Partially Dispatched" :
                  initialData?.quantity > initialData?.issued_quantity_posted && initialData?.issued_quantity_posted == 0 ? "Not Dispatched" : ""
            }</p>
        </section>

        {
          !editionMode && hasPermission("editPN") ? <Tooltip title="Edit PN" arrow>
            <button onClick={toggleEditionMode}>
              <i className='icon-edit'></i>
            </button>
          </Tooltip> : hasPermission("editPN") ? <Tooltip title={editionMode && hasPermission("editPN") ? "Save Changes" : ""} arrow>
            {
              // !initialData?.quantity == initialData?.issued_quantity_posted ?
              editionMode ?
                <button onClick={updatePart} style={{
                  background: "var(--black-mid)",
                  color: "var(--white)",
                  fontSize: ".8rem"
                }}>
                  <i className='icon-save'></i>
                </button> :
                <span style={{
                  width: "1.5rem",
                  height: "1.5rem"
                }}></span>
            }
          </Tooltip> : ""

        }
        {
          !editionMode && hasPermission("editPN") ? <Tooltip title={prnStatus == "Posted" ? "Cannot be deleted because the PRN status is Posted" : "Delete PN"} arrow>
            <button onClick={openDeleteDialog}>
              <i className='icon-delete-new' style={{
                opacity: prnStatus == "Posted" ? ".5" : "1",
              }}></i>
            </button>
          </Tooltip> : editionMode && hasPermission("editPN") ?

            <Tooltip title="Cancel Changes" arrow>
              <button style={{
                border: "1px solid #DDDDDD",
                fontSize: ".6rem"
              }}
                onClick={toggleEditionMode}
              >
                <i className='icon-cross'></i>
              </button>
            </Tooltip> : ""
        }
      </div>
    </section>
  );
};
